import {Menu, makeStyles} from '@material-ui/core'
import React from 'react'

const useMenuStyles = makeStyles(theme => ({
  paper: {
    border: `1px solid ${theme.palette.text.primary}`,
  },
}))

function StyledMenu(props) {
  const menuClasses = useMenuStyles()

  return (
    <Menu
      marginThreshold={0}
      disableScrollLock={true}
      getContentAnchorEl={null}
      classes={{
        paper: menuClasses.paper,
      }}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      disableRestoreFocus
      {...props}
    />
  )
}

export {StyledMenu}
